export const integrationsData = [
    {
        key: "google_calendar",
        description: "Automatically create meetings on Ziner and have it reflect on your Google calendar.",
        imageUrl: "https://res.cloudinary.com/gracy126/image/upload/v1758415041/Ziner/google-calendar.svg",
        category: ["calendar"],
        name: "Google Calendar",
        active: true,
    },
    {
        key: "calendly",
        description: "Capture booking data on Ziner from your Calendly bookings.",
        imageUrl: "https://cdn.brandfetch.io/idbJpTKFPT/idGx75u1Xb.svg?c=1bxid64Mup7aczewSAYMX&t=1657269347279",
        category: ["calendar"],
        name: "Calendly",
        active: false,
    },
    {
        key: "typeform",
        description: "Capture client data on Ziner from your Typeform form.",
        imageUrl: "https://cdn.brandfetch.io/idPkJ70vyb/theme/dark/logo.svg?c=1bxid64Mup7aczewSAYMX&t=1699355442358",
        category: ["data collection"],
        name: "Typeform",
        active: false,
    },
    {
        key: "zendesk",
        description: "Turn Zendesk tickets into tasks on Ziner.",
        imageUrl: "https://cdn.brandfetch.io/idNq8SRGPd/theme/dark/logo.svg?c=1bxid64Mup7aczewSAYMX&t=1722967423497",
        category: ["data collection"],
        name: "Zendesk",
        active: false,
    },
];